// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"_1nVE6","text":"_2bdhn","button":"_2WVeV","buttonText":"_3_83R"};